/**
 * Production-safe logging. Verbose diagnostics only emit in development
 * unless REACT_APP_DEBUG=true is set at build time.
 */
const DEBUG_ENABLED =
  process.env.NODE_ENV !== "production" ||
  process.env.REACT_APP_DEBUG === "true";

export function devLog(...args) {
  if (DEBUG_ENABLED) {
    console.log(...args);
  }
}

export function devWarn(...args) {
  if (DEBUG_ENABLED) {
    console.warn(...args);
  }
}

export function isDevDiagnosticsEnabled() {
  return DEBUG_ENABLED;
}
